<nz-modal
  nzWrapClassName="vertical-center-modal"
  nzClassName="charts-modal-container"
  [(nzVisible)]="modalVisible"
  nzTitle="Edit Tickers"
  (nzOnCancel)="handleModalCancel()"
  nzWidth="950px"
  nzHeight="500px"
>
  <ng-container *nzModalContent>
  <app-edit-charts-ticker
    [addRowTableData]="addRowTableData"
    [(watchlists)]="watchlistData"
    [recentlyVisitedCompanies]="recentlyVisitedCompanies"
    [peerCompanies]="peerCompanies"
    [mpt]="mpt"
    [maxHeight]="'320px'"
    [max]="max"
    (onChangeTickers)="onUpdateTickers($event)"
    #editChartsTicker
  >
  </app-edit-charts-ticker>
</ng-container>
  <div *nzModalFooter class="chart-tickers-modal-footer">
        <button
          nz-button
          nzType="default"
          (click)="handleModalCancel()"
          class="watchlist-btn"
        >
          <span>Cancel</span>
        </button>
        <button
          nz-button
          [title]="
          this.modalData.length > max ? 'Max number of tickers is ' + max : ''
        "
          nzType="primary"
          (click)="updateTickers()"
          [ngClass]="this.modalData.length > max ? 'disable-btn' : ''"
          [disabled]="this.modalData.length === 0"
        >
          <span>Update</span>
        </button>
  </div>
</nz-modal>
